import { useRouter } from "next/router";

import Footer from "../Footer/Footer";
import StaticInfoBanner from "../Infobanner/StaticInfoBanner";
import CollectionHome from "./CollectionHome";
import FeaturedHome from "./FeaturedHome";
import { ScrollProvider } from "./ScrollPositionProvider";

export const MainHome = ({ store, theme, hideHeroMedia }) => {
  const router = useRouter();

  const homeActive = store?.homeLayout === "featured" && !hideHeroMedia;
  const hasBanner = Boolean(store?.announcement?.trim());

  const updateHomeActive = () => {
    router.push("/collections/all");
  };

  return (
    <main className="flex min-h-screen w-screen max-w-app flex-col bg-background transition-[max-height] duration-200">
      {homeActive ? (
        <FeaturedHome
          theme={theme}
          store={store}
          updateHomeActive={updateHomeActive}
          heroPhotos={store?.heroPhotos}
        />
      ) : (
        <ScrollProvider>
          {hasBanner && <StaticInfoBanner text={store?.announcement} />}
          <CollectionHome store={store} theme={theme} hasBanner={hasBanner} />
        </ScrollProvider>
      )}

      <div className="mt-auto">
        <Footer />
      </div>
    </main>
  );
};
